import type { EnhancedStorePromotion } from '@marxbiotech/shared-types/medusa';

/**
 * Extract promotions array from cart object.
 * @param cart - Cart object (may be null or have missing promotions)
 * @returns Array of enhanced promotions
 */
export const getPromotionsFromCart = (
  cart: { promotions?: unknown[] } | null | undefined
): EnhancedStorePromotion[] => {
  return (cart?.promotions ?? []).filter(
    (p): p is EnhancedStorePromotion =>
      p !== null && typeof p === 'object' && 'code' in p
  );
};
